import { Component, OnInit } from "@angular/core";

@Component({
  selector: 'anie-coming-soon-notification',
  templateUrl: './coming-soon-notification.component.html',
  styleUrls: ['./coming-soon-notification.component.scss']
})
export class ComingSoonNotificationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
